import type { IconData } from '@stacksjs/iconify-core'

export const contrast: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M371 8q76 0 144 29t118 79t79 118t29 145t-29 144t-79 118t-118 80t-144.5 29T227 721t-118-80t-80-118T0 379t29-145t80-118t118-79T371 8m0 117q0-11-7-18t-19-5q-53 5-99 28t-80 61t-53 85t-20 103t20 102t53 86t80 60t99 29q11 1 19-6t7-17z\"/>",
  "width": 750,
  "height": 850,
  "viewBox": "0 0 750 850"
}

export default contrast
